var render, staticRenderFns
import script from "./OrderPage.vue?vue&type=script&lang=ts&"
export * from "./OrderPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OrderPage.vue"
export default component.exports